var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('loading',{attrs:{"active":_vm.$store.state.isLoading},on:{"update:active":function($event){return _vm.$set(_vm.$store.state, "isLoading", $event)}}}),_c('navbar'),_c('router-view',{staticClass:"router-view"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }